import { motion } from "framer-motion";
import { TRUST_POINTS } from "../data";

export const Stats = () => {
  return (
    <section
      className="relative overflow-hidden bg-navy grain py-20 sm:py-24"
      data-testid="stats"
    >
      <div className="relative z-10 mx-auto max-w-7xl px-4 sm:px-6 lg:px-10">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-y-12 gap-x-8">
          {TRUST_POINTS.map((t, i) => (
            <motion.div
              key={t.label}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: i * 0.1 }}
              data-testid={`trust-${i}`}
              className="border-l border-white/15 pl-5"
            >
              <span className="grid h-12 w-12 place-items-center rounded-2xl bg-white/10 text-teal ring-1 ring-white/15">
                <t.icon className="h-6 w-6" strokeWidth={2} />
              </span>
              <p className="mt-5 font-display text-lg sm:text-xl font-bold uppercase tracking-wide text-white leading-snug">
                {t.label}
              </p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Stats;
